/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { InjectionToken } from '@angular/core';
import { BooleanObject } from '@hcworkspace/sysque/toolbelt/feature';
import { Observable } from 'rxjs';
import { RotateElementReturnCodes } from '../../../../../../shared/ui/src/lib/enums/rotate-element-return-codes';
import { ShiftSegmentReturnCodes } from '../../../../../../shared/ui/src/lib/enums/shift-segment-return-codes';
import { RotateElementDirection } from '../../../../../../toolbelt/feature/src/lib/models/rotate-element-direction';
import { ShiftElementDirections } from '../../../../../../shared/ui/src/lib/enums/shift-segment-directions';

export interface IToolbeltFacade {
  sendPopupRoutingNoDialogs(itemName: string, selectedSystemName: string, selectedCategory: string): void;
  sendPopupRoutingWpfDialogs(itemName: string, selectedSystemName: string): void;
  sendPopupRoutingAction(itemName: any, width: number, height: number): void;
  selectProcessFitting(): Observable<BooleanObject>;
  getProcessStatus(): void;
  updateOnlyFitting(categoryName: string, isChecked: boolean): void;
  showNonStandard(isShowNonStandard: boolean): Observable<boolean>;
  rotateElement(rotateValue: number, rotateDirection: RotateElementDirection): Observable<RotateElementReturnCodes>;
  shiftElement(shiftDirection: ShiftElementDirections): Observable<ShiftSegmentReturnCodes>;
  processEnable(isEnable: boolean): void;
  updateLocalStorage(key: string, value: any): any;
  getLocalStorage(key: string): any;
  updateDispatchLocalStorage(key: string, value: any): void;
}

export const TOOLBELT_FACADE_TOKEN = new InjectionToken<IToolbeltFacade>('TOOLBELT_FACADE_TOKEN');
